// Panel (öğretmen/veli) navigasyon ve form seçenekleri — tek kaynak.
// Burada navigasyon yapısı ve statik form seçenekleri
// (sınav/ders/zorluk gibi gerçek kategori adları) tutulur.

export interface PanelMenuItem {
  label: string;
  href: string;
  icon: string;
}

export interface RoleLink {
  label: string;
  href: string;
  icon: string;
}

// Rol değiştirici — yalnızca public roller (öğrenci/veli).
// Öğretmen ve yönetici panelleri public UI'da gösterilmez.
export const roleSwitcherLinks: RoleLink[] = [
  { label: "Öğrenci", href: "/ogrenci", icon: "ri-graduation-cap-line" },
  { label: "Veli", href: "/veli", icon: "ri-heart-3-line" },
];

export const studentMenu: PanelMenuItem[] = [
  {label:"Soru Bankası",href:"/ogrenci/soru-bankasi",icon:"ri-question-line"},
  {label:"Bildirimler",href:"/ogrenci/bildirimler",icon:"ri-notification-3-line"},
  { label: "Ana Panel", href: "/ogrenci", icon: "ri-dashboard-line" },
  { label: "Haftalık Plan", href: "/ogrenci/haftalik-plan", icon: "ri-calendar-todo-line" },
  { label: "Hedeflerim", href: "/ogrenci/hedeflerim", icon: "ri-flag-line" },
  { label: "Derslerim", href: "/ogrenci/derslerim", icon: "ri-book-2-line" },
  { label: "Canlı Dersler", href: "/ogrenci/canli-dersler", icon: "ri-vidicon-line" },
  { label: "Ders Kayıtları", href: "/ogrenci/ders-kayitlari", icon: "ri-video-on-line" },
  { label: "Ders Programım", href: "/ogrenci/ders-programim", icon: "ri-calendar-line" },
  { label: "Video Dersler", href: "/ogrenci/video-dersler", icon: "ri-play-circle-line" },
  { label: "Deneme Sınavları", href: "/ogrenci/deneme-sinavlari", icon: "ri-file-text-line" },
  { label: "Ödevler", href: "/ogrenci/odevler", icon: "ri-task-line" },
  { label: "Yanlış Sorularım", href: "/ogrenci/yanlis-sorularim", icon: "ri-close-circle-line" },
  { label: "Notlarım", href: "/ogrenci/notlarim", icon: "ri-sticky-note-line" },
  { label: "Başarı Analizim", href: "/ogrenci/basari-analizim", icon: "ri-line-chart-line" },
  { label: "Öğretmenlerim", href: "/ogrenci/ogretmenlerim", icon: "ri-user-star-line" },
  { label: "Mesajlar", href: "/ogrenci/mesajlar", icon: "ri-chat-3-line" },
  { label: "Paketim", href: "/ogrenci/paketim", icon: "ri-vip-crown-line" },
  { label: "Profilim", href: "/ogrenci/profilim", icon: "ri-user-line" },
];

export const studentBottomNav: PanelMenuItem[] = [
  { label: "Ana Panel", href: "/ogrenci", icon: "ri-dashboard-line" },
  { label: "Dersler", href: "/ogrenci/derslerim", icon: "ri-book-2-line" },
  { label: "Ödevler", href: "/ogrenci/odevler", icon: "ri-task-line" },
  { label: "Mesajlar", href: "/ogrenci/mesajlar", icon: "ri-chat-3-line" },
];

export const ogretmenMenu: PanelMenuItem[] = [
  { label: "Ana Panel", href: "/ogretmen", icon: "ri-dashboard-line" },
  { label: "Öğrencilerim", href: "/ogretmen/ogrencilerim", icon: "ri-group-line" },
  { label: "Derslerim", href: "/ogretmen/derslerim", icon: "ri-book-2-line" },
  { label: "Canlı Dersler", href: "/ogretmen/canli-dersler", icon: "ri-vidicon-line" },
  { label: "Ders Programım", href: "/ogretmen/ders-programim", icon: "ri-calendar-line" },
  { label: "Video Dersler", href: "/ogretmen/video-dersler", icon: "ri-play-circle-line" },
  { label: "AI Video Ders", href: "/ogretmen/ai-video-ders", icon: "ri-magic-line" },
  { label: "Soru Ekle", href: "/ogretmen/soru-ekle", icon: "ri-add-circle-line" },
  { label: "Test Oluştur", href: "/ogretmen/test-olustur", icon: "ri-file-list-3-line" },
  { label: "Deneme Oluştur", href: "/ogretmen/deneme-olustur", icon: "ri-file-text-line" },
  { label: "Ödevler", href: "/ogretmen/odevler", icon: "ri-task-line" },
  { label: "Öğrenci Analizleri", href: "/ogretmen/ogrenci-analizleri", icon: "ri-line-chart-line" },
  { label: "AI Öğrenci Geçmişi", href: "/ogretmen/ai-gecmisi", icon: "ri-brain-line" },
  { label: "Mesajlar", href: "/ogretmen/mesajlar", icon: "ri-chat-3-line" },
  { label: "Profil", href: "/ogretmen/profil", icon: "ri-user-line" },
];

export const veliMenu: PanelMenuItem[] = [
  { label: "Ana Panel", href: "/veli", icon: "ri-dashboard-line" },
  { label: "Dersler", href: "/veli/dersler", icon: "ri-book-2-line" },
  { label: "Deneme Sonuçları", href: "/veli/deneme-sonuclari", icon: "ri-file-text-line" },
  { label: "Ödevler", href: "/veli/odevler", icon: "ri-task-line" },
  { label: "Devamsızlık", href: "/veli/devamsizlik", icon: "ri-user-unfollow-line" },
  { label: "Haftalık Rapor", href: "/veli/haftalik-rapor", icon: "ri-bar-chart-line" },
  { label: "Meraklı Kontrolü", href: "/veli/merakli-kontrolu", icon: "ri-computer-line" },
  { label: "AI Öğrenci Analizi", href: "/veli/ai-analiz", icon: "ri-brain-line" },
  { label: "Mesajlar", href: "/veli/mesajlar", icon: "ri-chat-3-line" },
  { label: "Profil", href: "/veli/profil", icon: "ri-user-line" },
];

export interface RoleConfig {
  roleLabel: string;
  homePath: string;
  homeLabel: string;
  menu: PanelMenuItem[];
  bottomNav: PanelMenuItem[];
  privateRole: boolean;
}

export const ogretmenConfig: RoleConfig = {
  roleLabel: "Öğretmen",
  homePath: "/ogretmen",
  homeLabel: "Öğretmen Paneli",
  menu: ogretmenMenu,
  bottomNav: [
    { label: "Ana Panel", href: "/ogretmen", icon: "ri-dashboard-line" },
    { label: "Derslerim", href: "/ogretmen/derslerim", icon: "ri-book-2-line" },
    { label: "Ödevler", href: "/ogretmen/odevler", icon: "ri-task-line" },
    { label: "Mesajlar", href: "/ogretmen/mesajlar", icon: "ri-chat-3-line" },
  ],
  privateRole: true,
};
export const veliConfig: RoleConfig = {
  roleLabel: "Veli",
  homePath: "/veli",
  homeLabel: "Veli Paneli",
  menu: veliMenu,
  bottomNav: [
    { label: "Ana Panel", href: "/veli", icon: "ri-dashboard-line" },
    { label: "Dersler", href: "/veli/dersler", icon: "ri-book-2-line" },
    { label: "Ödevler", href: "/veli/odevler", icon: "ri-task-line" },
    { label: "Rapor", href: "/veli/haftalik-rapor", icon: "ri-bar-chart-line" },
  ],
  privateRole: false,
};
export const adminMenu: PanelMenuItem[] = [
  { label: "Ana Panel", href: "/yonetici", icon: "ri-dashboard-line" },
  { label: "Kullanıcılar", href: "/yonetici/kullanicilar", icon: "ri-group-line" },
  { label: "Kurumlar", href: "/yonetici/kurumlar", icon: "ri-building-4-line" },
  { label: "Roller ve Yetkiler", href: "/yonetici/roller", icon: "ri-shield-keyhole-line" },
  { label: "İçerik Yönetimi", href: "/yonetici/icerikler", icon: "ri-stack-line" },
  { label: "Canlı Dersler", href: "/yonetici/canli-dersler", icon: "ri-vidicon-line" },
  { label: "Sınavlar", href: "/yonetici/sinavlar", icon: "ri-file-list-3-line" },
  { label: "Eğitim İçerikleri", href: "/yonetici/egitim-icerikleri", icon: "ri-book-open-line" },
  { label: "Paketler", href: "/yonetici/paketler", icon: "ri-vip-crown-line" },
  { label: "Ödemeler", href: "/yonetici/odemeler", icon: "ri-bank-card-line" },
  { label: "Borçlular", href: "/yonetici/borclular", icon: "ri-wallet-3-line" },
  { label: "SMS Bildirimi", href: "/yonetici/sms-bildirim", icon: "ri-message-3-line" },
  { label: "Destek Talepleri", href: "/yonetici/destek", icon: "ri-question-answer-line" },
  { label: "Denetim Kaydı", href: "/yonetici/denetim-kaydi", icon: "ri-history-line" },
  { label: "Yapay Zekâ Yönetimi", href: "/yonetici/ai-yonetimi", icon: "ri-brain-line" },
  { label: "Sistem Ayarları", href: "/yonetici/ayarlar", icon: "ri-settings-3-line" },
];

export const adminConfig: RoleConfig = {
  roleLabel: "Yönetici",
  homePath: "/yonetici",
  homeLabel: "Yönetici Paneli",
  menu: adminMenu,
  bottomNav: [
    { label: "Ana Panel", href: "/yonetici", icon: "ri-dashboard-line" },
    { label: "Kullanıcılar", href: "/yonetici/kullanicilar", icon: "ri-group-line" },
    { label: "İçerikler", href: "/yonetici/icerikler", icon: "ri-stack-line" },
    { label: "Ayarlar", href: "/yonetici/ayarlar", icon: "ri-settings-3-line" },
  ],
  privateRole: true,
};
// Form önizlemeleri için statik seçenek listeleri (gerçek kategori adları).
export const examTypes = ["TYT", "AYT", "YDT", "LGS", "KPSS", "DGS", "ALES", "YDS", "YÖKDİL"];

export const gradeOptions = [
  "Okul Öncesi",
  "1. Sınıf",
  "2. Sınıf",
  "3. Sınıf",
  "4. Sınıf",
  "5. Sınıf",
  "6. Sınıf",
  "7. Sınıf",
  "8. Sınıf (LGS)",
  "9. Sınıf",
  "10. Sınıf",
  "11. Sınıf",
  "12. Sınıf (YKS)",
  "Mezun",
];

export const subjectOptions = [
  "Matematik",
  "Geometri",
  "Türkçe",
  "Türk Dili ve Edebiyatı",
  "İngilizce",
  "Hayat Bilgisi",
  "Fen Bilimleri",
  "Sosyal Bilgiler",
  "Fizik",
  "Kimya",
  "Biyoloji",
  "Tarih",
  "T.C. İnkılap Tarihi ve Atatürkçülük",
  "Coğrafya",
  "Felsefe",
  "Din Kültürü ve Ahlak Bilgisi",
];

export const difficultyOptions = ["Kolay", "Orta", "Zor"];
